
const HIDayData2025 = [
    {
        id: 1,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_1.webp")
    },
    {
        id: 2,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_2.webp")
    },
    {
        id: 3,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_3.webp")
    },
    {
        id: 4,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_4.webp")
    },
    {
        id: 5,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_5.webp")
    },
    {
        id: 6,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_6.webp")
    },
    {
        id: 7,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_7.webp")
    },
    {
        id: 8,
        imageSource: require("../../../Assets/Events/2025/Happy_Independence_Day_2025/HIDay_25_8.webp")
    }
];

export default HIDayData2025;